import { render, staticRenderFns } from "./PrintRooms.vue?vue&type=template&id=62c27b23&scoped=true&"
import script from "./PrintRooms.vue?vue&type=script&lang=js&"
export * from "./PrintRooms.vue?vue&type=script&lang=js&"
import style0 from "./PrintRooms.vue?vue&type=style&index=0&id=62c27b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c27b23",
  null
  
)

export default component.exports